var _g, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      width: "100%",
      height: "100%"
    },
    width: 100,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    id: "svg10222830966",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.334 12.5)",
    id: "ss10222830966_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 14.607 54.132 L 25.131 25.12 C 27.044 21.093 29.971 17.762 33.324 25.75 C 36.419 33.124 41.037 46.626 43.763 54.147 M 19.389 41.675 L 38.839 41.675",
    fill: "#000000",
    strokeWidth: "3px",
    stroke: "#FFFCF5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6.102 5.492 C 0 10.983 0 19.822 0 37.5 C 0 55.177 0 64.017 6.102 69.508 C 12.204 75 22.025 75 41.666 75 C 61.307 75 71.129 75 77.23 69.508 C 83.332 64.017 83.332 55.178 83.332 37.5 C 83.332 19.822 83.332 10.983 77.23 5.492 C 71.13 0 61.308 0 41.667 0 C 22.025 0 12.204 0 6.102 5.492 Z",
    fill: "#000000",
    strokeWidth: "3px",
    stroke: "#FFFCF5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 68.684 24.945 L 68.684 37.423 M 68.684 37.423 L 68.684 53.855 M 68.684 37.423 L 60.274 37.423 C 59.274 37.423 58.284 37.609 57.352 37.971 C 50.294 40.709 50.294 50.885 57.352 53.623 C 58.284 53.985 59.275 54.171 60.275 54.171 L 68.685 54.171",
    fill: "#000000",
    strokeWidth: "3px",
    stroke: "#FFFCF5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "",
    fillOpacity: 0
  }))))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#svg10222830966"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAd);
export default __webpack_public_path__ + "static/media/ad.ffbd68fe18fe92d9f49c15f43980e6af.svg";
export { ForwardRef as ReactComponent };